<template>
  <section class="categorie">
    <div
      class="d-flex align-items-center justify-content-between justify-content-md-around my-4 scroolbar flex-nowrap"
    >
      <div
        class="order-2 d-inline-flex flex-column justify-content-around align-items-center px-3"
      >
        <button
          type="button"
          class="btn btn-outline-info btn_categorie "
          @click="SelectRepertoire()"
          :class="{ active: isActive }"
        >
          <font-awesome-icon icon="file" size="2x" />
        </button>
        <span class="text-info span_categorie">Affichage obligatoire</span>
      </div>

      <div
        class="order-5 d-inline-flex flex-column justify-content-around align-items-center px-3"
      >
        <button
          type="button"
          class="btn btn-outline-dark btn_categorie"
          @click="SelectBoutique()"
        >
          <font-awesome-icon icon="store-alt" size="2x" />
        </button>
        <span class="text-dark span_categorie">Boutique</span>
      </div>

      <div
        class="order-1 d-inline-flex flex-column justify-content-around align-items-center px-3"
      >
        <button
          type="button"
          class="btn btn-outline-secondary btn_categorie"
          @click="SelectNews()"
        >
          <font-awesome-icon icon="info" size="2x" />
        </button>
        <span class="text-secondary span_categorie">News</span>
      </div>

      <div
        class="order-4 d-inline-flex flex-column justify-content-around align-items-center px-3"
      >
        <button
          type="button"
          class="btn btn-outline-success btn_categorie"
          @click="SelectOffre()"
        >
          <font-awesome-icon icon="clipboard-list" size="2x" />
        </button>
        <span class="text-success span_categorie">Offre d'emploi</span>
      </div>

      <div
        class="order-3 d-inline-flex flex-column justify-content-around align-items-center px-3 "
      >
        <button
          type="button"
          class="btn btn-outline-primary btn_categorie"
          @click="SelectPrevention()"
        >
          <font-awesome-icon icon="shield-alt" size="2x" />
        </button>
        <span class="text-primary span_categorie">Prévention</span>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in">
      <Repertoire class="repertoire" v-if="RepertoireSelect"></Repertoire>
      <Boutique class="repertoire" v-if="BoutiqueSelect"></Boutique>
      <News class="repertoire" v-if="NewsSelect"></News>
      <Offre class="repertoire" v-if="OffreSelect"></Offre>
      <Prevention class="repertoire" v-if="PreventionSelect"></Prevention>
    </transition>
  </section>
</template>

<script>
// Import Repertoire
import Repertoire from "@/components/repertoire/Repertoire.vue";
import Boutique from "@/components/repertoire/Boutique.vue";
import News from "@/components/repertoire/News.vue";
import Offre from "@/components/repertoire/Offre.vue";
import Prevention from "@/components/repertoire/Prevention.vue";

export default {
  name: "categorie",
  data() {
    return {
      RepertoireSelect: false,
      BoutiqueSelect: false,
      NewsSelect: false,
      OffreSelect: false,
      PreventionSelect: false,
      isActive: false
    };
  },
  methods: {
    SelectRepertoire() {
      this.RepertoireSelect = true;
      this.BoutiqueSelect = false;
      this.NewsSelect = false;
      this.OffreSelect = false;
      this.PreventionSelect = false;
    },
    SelectBoutique() {
      this.BoutiqueSelect = true;
      this.RepertoireSelect = false;
      this.NewsSelect = false;
      this.OffreSelect = false;
      this.PreventionSelect = false;
      this.isActive = false;
    },
    SelectNews() {
      this.NewsSelect = true;
      this.BoutiqueSelect = false;
      this.RepertoireSelect = false;
      this.OffreSelect = false;
      this.PreventionSelect = false;
      this.isActive = false;
    },
    SelectOffre() {
      this.OffreSelect = true;
      this.BoutiqueSelect = false;
      this.RepertoireSelect = false;
      this.NewsSelect = false;
      this.PreventionSelect = false;
      this.isActive = false;
    },
    SelectPrevention() {
      this.PreventionSelect = true;
      this.OffreSelect = false;
      this.BoutiqueSelect = false;
      this.RepertoireSelect = false;
      this.NewsSelect = false;
      this.isActive = false;
    }
  },
  components: {
    Repertoire,
    Boutique,
    News,
    Offre,
    Prevention
  },
  mounted() {
    this.RepertoireSelect = true;
    this.isActive = true;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn_categorie {
  width: 5rem;
  height: 5rem;
  /* Centrer et aligner image dans button */
  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
}

.span_categorie {
  height: 2rem;
  margin-top: 0.5rem;
  font-size: 0.9em;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
    .slide-fade-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */
 {
  transform: translateX(10px);
  opacity: 0;
}

.repertoire {
  height: 50vh;
}

.scroolbar {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
</style>
